import { useState } from 'react';
// @mui
import { SxProps, TableCell, TableRow, useTheme, Theme } from '@mui/material';

import TableMoreMenu from './TableMoreMenu';

interface Props {
  sx?: SxProps<Theme>;
  rowConfig: {
    id: string;
    align?: string;
    renderValue?: (v: any, style: SxProps<Theme>) => any;
    custom?: string;
    hide?: boolean;
  }[];
  row: any;
  avatar?: JSX.Element;
  actions?: JSX.Element | null;
}

const TableRowCustom: React.FC<Props> = ({ rowConfig, row, sx, avatar, actions }) => {
  const theme = useTheme();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const linkStyle = {
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme?.palette?.primary?.main,
  };

  return (
    <TableRow hover sx={{ '& .MuiTableCell-root': { p: { xs: 1, md: 1.5 } }, height: 60, background: theme => theme.palette.background.paper, ...sx }}>
      {avatar && (
        <TableCell sx={{ p: 1, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}>{avatar}</TableCell>
      )}
      {rowConfig?.map((cell: any) => {
        return (
          <TableCell
            key={cell?.id}
            align={cell?.align || 'left'}
            sx={{ p: 1, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
          >
            {cell?.hide ? (
              <></>
            ) : (
              <>
                {cell?.custom && cell.custom === 'moreMenu' ? (
                  <TableMoreMenu
                    open={openMenu}
                    onOpen={handleOpenMenu}
                    onClose={handleCloseMenu}
                    actions={actions}
                  />
                ) : (
                  <>{cell?.renderValue(row, linkStyle)}</>
                )}
              </>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableRowCustom;
